// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f5UP0{height:24px;width:24px;object-fit:contain;display:flex;align-items:center;justify-content:center}.mj1LU{width:auto;min-width:24px}.UZZmJ{visibility:hidden;width:0;height:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `f5UP0`,
	"fullLogo": `mj1LU`,
	"loadingLogoImage": `UZZmJ`
};
export default ___CSS_LOADER_EXPORT___;
